import { useEffect, useState } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { ResetBtn, UseBtn } from 'libs/ui';
import { Container, Input, ParkingFilter, ButtonsContainer, DoubleField, DateSelect, DateTime } from 'libs/form';

const initial = {};

const RollbackFilter = (props) => {
  const { setInitial, reset, handleSubmit, change, theme } = props;

  const { t } = useTranslation();

  // did mount
  useEffect(() => {
    setInitial(initial);
    return () => {
      reset();
      setInitial(initial);
    };
  }, []);

  return (
    <Container theme={theme} className="cp-filter">
      <form onSubmit={handleSubmit}>
        <DateSelect from_name="ts_from" to_name="ts_to" change={change}>
          <DoubleField>
            <DateTime label={t('grid.Дата и время')} width="160px" name="ts_from" type="dateTime" />
            <DateTime width="160px" name="ts_to" type="dateTime" />
          </DoubleField>
        </DateSelect>

        <DoubleField>
          <Input width="80px" name="amount_from" type="text" withZero EmptyOnExit label={t('grid.Сумма')} placeholder={t('filter.От')} naturalNumber />
          <Input width="80px" name="amount_to" type="text" withZero EmptyOnExit placeholder={t('filter.До')} naturalNumber />
        </DoubleField>

        <Input width="150px" name="vehicle_plate" type="text" label={t('sections.ГРЗ')} placeholder={t('form.А000AA 000 rus')} />

        <Input width="150px" name="mean_id" type="text" label={t('grid.Номер платежа')} placeholder={'43D52046AFC6'} />

        <ParkingFilter />

        <ButtonsContainer>
          <ResetBtn onClick={reset} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'RollbackFilter',
  destroyOnUnmount: false,
  initialValues: initial,
})(RollbackFilter);
